import { useMemo } from "react";
import { useGoalsQuery } from "web_myplann/Api/Goals/useGoalsQuery";
import { mapGoalListItemDto } from "web_myplann/Goals/Mappers/mapGoalListItemDto";
import type { Goal } from "web_myplann/Goals/Types/GoalTypes";
import { GoalStateEnum } from "web_myplann/Infrastructure/Api/Api";

export const useCompletedGoals = (): { goals: Goal[]; isPending: boolean } => {
	const { data: goalsResponse, isPending } = useGoalsQuery([
		GoalStateEnum.Completed,
	]);

	const goals = useMemo(
		() =>
			(goalsResponse?.data ?? []).map((dto) =>
				mapGoalListItemDto({ dto, completed: true }),
			),
		[goalsResponse],
	);

	return { goals, isPending };
};
